export default __webpack_public_path__ + "static/media/foldermiddle.14b56043.svg";